import { getInitials } from "@/utils/functions/helperFunctions";

interface AvatarProps {
    name: string;
    id: string;
}

const Avatar: React.FC<AvatarProps> = ({ name, id }) => {
    return (
        <span className="gs-user-avatar" id={`${id}-avatar`}>
            <span id={`${id}-name-initials`}>{getInitials(name)}</span>
        </span>
    );
};

export default Avatar;
